import { memo, useCallback } from 'react';
import {
  fetchQuests,
  selectQuests,
  selectQuestsDataState,
} from '../state/quests.slice';
import { useDispatch, useSelector } from '@bonanza-social/toolkit/state';
import { List, Box, useBreakpointProp } from '@bonanza-social/moonlight';
import { ListRenderItem } from 'react-native';
import QuestItem from '../components/QuestItem/QuestItem';
import QuestSkeleton from '../components/QuestItem/components/QuestSkeleton';
import { QuestListEmpty } from '../components/QuestsEmptyState/QuestListEmpty';
import { useFocusEffect } from '@bonanza-social/navigation';

function QuestsList() {
  const dispatch = useDispatch();
  const quests = useSelector(selectQuests);
  const questsDataState = useSelector(selectQuestsDataState);

  useFocusEffect(
    useCallback(() => {
      dispatch(fetchQuests());
    }, [dispatch]),
  );
  const numColumns = useBreakpointProp({
    mobile: undefined,
    tablet: 2,
    desktop: 3,
  });

  const renderItem = useCallback<ListRenderItem<(typeof quests)[number]>>(
    ({ item, index }) => <QuestItem key={index} id={item.promotionId} />,
    [],
  );

  return (
    <Box flex={1}>
      <List
        data={quests}
        renderItem={renderItem}
        keyboardDismissMode="interactive"
        keyboardShouldPersistTaps="handled"
        contentContainerStyle={{
          width: '100%',
          maxWidth: {
            mobile: undefined,
            tablet: undefined,
            desktop: 'max-page-width',
          },
          marginHorizontal: {
            mobile: undefined,
            tablet: undefined,
            desktop: 'auto',
          },
        }}
        key={numColumns}
        numColumns={numColumns}
        {...(numColumns
          ? {
              columnWrapperStyle: {
                alignItems: 'stretch',
                gap: {
                  mobile: undefined,
                  tablet: 'space-400',
                  desktop: 'space-400',
                },
                justifyContent: {
                  mobile: undefined,
                  tablet: 'flex-start',
                  desktop: 'flex-start',
                },
              },
            }
          : {})}
        ListEmptyComponent={() => {
          if (questsDataState === 'rejected') {
            return <QuestListEmpty state="rejected" />;
          }
          if (questsDataState === 'fulfilled') {
            return <QuestListEmpty state="empty" />;
          }
          return <QuestSkeleton />;
        }}
      />
    </Box>
  );
}

export default memo(QuestsList);
